import * as React from 'react'
import styles from './style.module.css';
import IconProvider from '../../../design-system/lib/IconProvider';
import { adsigne, box_gray, DRIVER_COLOR, kmaway } from '../../../assets';
import Typography from '../../../design-system/lib/Typography';
import { useTranslation } from 'react-i18next';




function DriverListItem_AA({data , onclick}) {
      const { t } = useTranslation();
  
  return (
    <div className={styles.CustomerListItemContainer} onClick={onclick && onclick}>
        <img src={data.avatarPhoto} size='16' className={styles.avatar+" "+`${data.activeOrdersCount  > 0 && styles.withOrder}`} />

        <div className={styles.twoColumnContaiiner}>
            <span className={styles.name}>
                {data.name}
            </span>
            <span className={styles.orders}>
                <img style={{ width: "14px", height: "14px" }} src={adsigne} />{data.username} {/* {ordersCount} {t("Orders")} */}

                <span style={{ height: "16px", width: "1px", backgroundColor: "rgba(128, 128, 128, 0.2)", margin: "0px 4px" }} />

                <img style={{ width: "14px", height: "14px" }} src={box_gray} />{data.activeOrdersCount  || 0} {/* {ordersCount} {t("Orders")} */}
                {data.distance && <>    <span style={{ height: "16px", width: "1px", backgroundColor: "rgba(128, 128, 128, 0.2)", margin: "0px 4px" }} />

                <img style={{ width: "14px", height: "14px" }} src={kmaway} /> {String(t("xxxaway")).replace("xxx", ConvertMeter(data.distance))}  
                </>}
            
            </span>
        </div>
    </div>
  )
}

export default DriverListItem_AA



function ConvertMeter(distance) {
  if (distance < 1000) {
    return (distance).toFixed(1) + "m";
  }else {
    return (distance / 1000).toFixed(1) + "km";
  }
  
}